import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";
import {RouteComponent} from "../-routeComponent";
import {getAuthenticationUserRowsWithCaching} from "../-queries";

export {AUTHENTICATION_USERS_QUERY_KEY} from "../-queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/authentication/")({
    loader: async ({context}) => {
        const users = await getAuthenticationUserRowsWithCaching({
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        });

        return {
            users,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
